import { selectableGuideTargets, describeGuideElement } from './registry'

// Selection captures before Vue/Vuetify handlers, including mousedown activators.
// Navigation mode deliberately installs no pointer interception.
export function createGuidePicker({ mode, onPick, onCancel, onHover, document: doc = document }) {
  let outlined = new Set()
  const ignored = event => event.target && event.target.closest && event.target.closest('[data-guide-picker-toolbar]')
  const entries = () => selectableGuideTargets().filter(entry => !entry.element.closest('[data-guide-editor]'))
  const find = event => {
    let node = event.target
    const available = entries()
    while (node && node !== doc) {
      const entry = available.find(item => item.element === node)
      if (entry) return entry
      node = node.parentElement
    }
    return null
  }
  const refresh = () => {
    const current = new Set(mode() === 'select' ? entries().map(entry => entry.element) : [])
    outlined.forEach(element => { if (!current.has(element)) element.classList.remove('guide-picker-target') })
    current.forEach(element => element.classList.add('guide-picker-target'))
    outlined = current
  }
  const block = event => { event.preventDefault(); event.stopImmediatePropagation() }
  const pointer = event => {
    if (mode() !== 'select' || ignored(event)) return
    // Do not let a miss execute a mutation while the user is choosing a target.
    block(event)
    const entry = find(event)
    if (event.type === 'click' && entry) onPick(describeGuideElement(entry.element))
  }
  const hover = event => {
    if (mode() !== 'select' || ignored(event)) return onHover(null)
    const entry = find(event)
    onHover(entry ? { ...describeGuideElement(entry.element), x: event.clientX, y: event.clientY } : null)
  }
  const key = event => {
    if (event.key === 'Escape') { block(event); onCancel(); return }
    // Keyboard activation must not execute the hovered/focused control in select mode.
    if (mode() === 'select' && !ignored(event) && ['Enter', ' ', 'Tab'].includes(event.key)) block(event)
  }
  const pointerEvents = ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click', 'dblclick', 'contextmenu']
  pointerEvents.forEach(name => doc.addEventListener(name, pointer, { capture: true, passive: false }))
  doc.addEventListener('mousemove', hover, true)
  doc.addEventListener('keydown', key, true)
  const observer = new MutationObserver(refresh)
  observer.observe(doc.body, { childList: true, subtree: true })
  const timer = setInterval(refresh, 200)
  refresh()
  return {
    refresh,
    destroy() {
      pointerEvents.forEach(name => doc.removeEventListener(name, pointer, true))
      doc.removeEventListener('mousemove', hover, true)
      doc.removeEventListener('keydown', key, true)
      observer.disconnect(); clearInterval(timer)
      outlined.forEach(element => element.classList.remove('guide-picker-target'))
      outlined.clear(); onHover(null)
    },
  }
}
